/** Whether following `next` from `start` leads back to `start`. */
export function reachesItself<T>(
  start: T,
  next: (node: T) => readonly T[],
): boolean {
  const seen = new Set<T>();
  const stack = [...next(start)];
  while (stack.length) {
    const node = stack.pop();
    if (node === undefined || seen.has(node)) continue;
    if (node === start) return true;
    seen.add(node);
    stack.push(...next(node));
  }
  return false;
}
